<template>
  <div class="confirmation">
    <v-container v-if="$vuetify.breakpoint.smAndUp">
      <v-row class="pt-5">
        <breadcrumbs :breadcrumbs="breadcrumbs" />
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-stepper alt-labels v-model="step">
            <v-stepper-header>
              <v-stepper-step step="1" color="appGreen" complete
                >MY BASKET</v-stepper-step
              >

              <v-divider class="active"></v-divider>

              <v-stepper-step step="2" color="appGreen" complete
                >DELIVERY & PAYMENT</v-stepper-step
              >

              <v-divider class="active"></v-divider>

              <v-stepper-step step="3" color="appGreen" complete
                >THANK YOU</v-stepper-step
              >
            </v-stepper-header>
          </v-stepper>
        </v-col>
      </v-row>
      <v-row class="information-wrapper mb-5">
        <v-col cols="12">
          <div class="header">
            <h2>Thank you! for ordering with Dentoholic.</h2>
            <div>
              <p>Check your inbox shortly for confirmation email</p>
              <p>Order# {{ order.number }}</p>
            </div>
          </div>
          <v-divider horizontal></v-divider>
          <v-row class="information-panel">
            <v-col cols="12" sm="6">
              <div class="item">
                <div class="item-header">
                  <h2>Delivery for</h2>
                  <!-- <div class="underline">Edit</div> -->
                </div>
                <div class="item-content">
                  {{ order.user.firstName + " " + order.user.lastName }} <br />
                  0723 8975 3945
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row
        class="order-content mb-4"
        v-for="item in order.items"
        :key="item.number"
      >
        <v-col cols="12" class="supplier-order">
          <div
            class="d-flex align-center"
            :class="{
              'justify-center': $vuetify.breakpoint.xsOnly,
              'justify-space-between': $vuetify.breakpoint.smAndUp
            }"
          >
            <h2 class="text-decoration-underline pl-4">
              Supplier order #{{ item.number }}
            </h2>
            <v-img
              v-if="$vuetify.breakpoint.smAndUp"
              class="flex-grow-0 mr-2"
              width="36"
              height="36"
              :src="item.logo"
            ></v-img>
          </div>
        </v-col>
        <v-col cols="12" v-if="$vuetify.breakpoint.smAndUp">
          <v-divider horizontal></v-divider>
        </v-col>

        <v-col cols="12 pa-3" v-if="$vuetify.breakpoint.mobile">
          <div
            class="order-item"
            v-for="(orderItem, index) in item.orderItems"
            :key="index"
          >
            <div class="order-product-images">
              <v-carousel
                hide-delimiters
                :show-arrows="orderItem.images.length > 1"
                height="114"
                v-model="carousel"
                v-if="orderItem.images.length > 0"
              >
                <v-carousel-item
                  v-for="image in orderItem.images"
                  :key="image.id"
                  :src="image.imageUrl"
                ></v-carousel-item>
              </v-carousel>
              <v-carousel
                hide-delimiters
                :show-arrows="false"
                height="114"
                v-model="carousel"
                v-else
              >
                <v-carousel-item
                  src="https://i.stack.imgur.com/y9DpT.jpg"
                ></v-carousel-item>
              </v-carousel>
            </div>
            <div class="order-info">
              <div class="order-header">
                <div class="order-title">{{ orderItem.name }}</div>
                <v-img
                  class="flex-grow-0"
                  width="25"
                  height="25"
                  :src="orderItem.brand.logo"
                ></v-img>
              </div>
              <div class="order-desc mt-2">
                <span>{{
                  orderItem.description.length > 50
                    ? orderItem.description.substring(0, 50)
                    : orderItem.description
                }}</span>
                <span
                  v-if="orderItem.description.length > 50"
                  @click="openDescription(orderItem.description)"
                  class="font-16 appGreen--text pointer"
                >
                  ....
                </span>
              </div>
              <div class="order-price">
                <div class="d-flex justify-space-between">
                  <div>Quantity:</div>
                  <div>{{ orderItem.quantity }}</div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Price:</div>
                  <div>£{{ orderItem.amountPerItem }}</div>
                </div>
                <div class="d-flex justify-space-between">
                  <div>Total:</div>
                  <div>
                  £{{ orderItem.amount }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12 pa-3" v-if="$vuetify.breakpoint.smAndUp">
          <v-row v-for="(orderItem, index) in item.items" :key="index">
            <v-col cols="2">
              <v-carousel
                hide-delimiters
                :show-arrows="orderItem.images.length > 1"
                height="150"
                v-model="carousel"
                v-if="orderItem.images.length > 0"
              >
                <v-carousel-item
                  v-for="image in orderItem.images"
                  :key="image.id"
                  :src="image.imageUrl"
                ></v-carousel-item>
              </v-carousel>
              <v-carousel
                hide-delimiters
                :show-arrows="false"
                height="150"
                v-model="carousel"
                v-else
              >
                <v-carousel-item
                  src="https://i.stack.imgur.com/y9DpT.jpg"
                ></v-carousel-item>
              </v-carousel>
            </v-col>
            <v-col cols="5">
              <h2 class="header">{{ orderItem.name }}</h2>
              <div class="body-2 mt-4">
                {{
                  orderItem.description.length > 94
                    ? orderItem.description.substring(0, 90)
                    : orderItem.description
                }}
                <span
                  v-if="orderItem.description.length > 94"
                  @click="openDescription(orderItem.description)"
                  class="font-16 appGreen--text pointer"
                >
                  ....
                </span>
              </div>
            </v-col>
            <v-col cols="5" class="pr-8">
              <div class="d-flex justify-space-between body-2 text-right">
                <div class="w-33">Quantity</div>
                <div class="w-33">Price</div>
                <div class="w-33">Total</div>
              </div>
              <div
                class="mt-10 d-flex justify-space-between text-right body-2 font-weight-bold"
              >
                <div class="w-33">{{ orderItem.quantity }}</div>
                <div class="w-33">
                  {{ orderItem.currency | currencySymbol
                  }}{{ orderItem.amountPerItem }}
                </div>
                <div class="w-33">
                  £{{ orderItem.amount }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" v-if="index !== orders.length - 1">
              <v-divider horizontal></v-divider>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <div class="checkout-panel order-checkout-panel">
            <v-col cols="12" class="pl-sm-5">
              <v-row>
                <v-col cols="12" sm="12" md="6" class="body-2">
                  <div
                    class="font-weight-bold d-flex justify-space-between d-sm-block"
                  >
                    Shipping to: {{ order.shipment | shortShipmentAddress }}
                    <!-- <a
                      @click="openShippingEditModal(order.shipment)"
                      class="ml-3 edit"
                      >Edit</a
                    > -->
                  </div>
                  <div>1 - 3 Days Delivery. Estimated arrival</div>
                  <div>between 03 August 2020 | 16 August 2020</div>
                </v-col>
                <v-col
                  class="order-cost"
                  cols="12"
                  v-if="$vuetify.breakpoint.xsOnly"
                >
                  <div class="d-flex justify-space-between">
                    <div>Subtotal</div>
                    <div>
                      {{ item.price.currency | currencySymbol
                      }}{{ item.price.subTotal }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between">
                    <div>Shipping</div>
                    <div>
                      {{ item.price.currency | currencySymbol
                      }}{{ item.price.shippingFee }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between">
                    <div>Discount</div>
                    <div>
                      {{ item.price.currency | currencySymbol
                      }}{{ item.price.discount }}
                    </div>
                  </div>
                </v-col>
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  class="d-flex justify-space-between flex-grow-1 order-total"
                >
                  <div>Total</div>
                  <div>
                    {{ item.price.currency | currencySymbol
                    }}{{
                      item.price.subTotal +
                        item.price.shippingFee +
                        item.price.discount
                    }}
                  </div>
                </div>
                <v-col
                  v-if="$vuetify.breakpoint.smAndUp"
                  cols="12"
                  sm="12"
                  md="6"
                  class="cost-panel"
                >
                  <v-row>
                    <v-col cols="9">
                      <span>Sub Total</span>
                    </v-col>
                    <v-col cols="2">
                      <span
                        >{{ item.price.currency | currencySymbol
                        }}{{ item.price.subTotal }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="9">
                      <span>Shipping</span>
                    </v-col>
                    <v-col cols="2">
                      <span
                        >{{ item.price.currency | currencySymbol
                        }}{{ item.price.shippingFee }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="9">
                      <span>Discount</span>
                    </v-col>
                    <v-col cols="2">
                      <span
                        >{{ item.price.currency | currencySymbol
                        }}{{ item.price.discount }}</span
                      >
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="9">
                      <span>Total</span>
                    </v-col>
                    <v-col cols="2">
                      <span
                        >{{ item.price.currency | currencySymbol
                        }}{{
                          item.price.subTotal +
                            item.price.shippingFee +
                            item.price.discount
                        }}</span
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-col>
      </v-row>

      <v-row
        class="checkout-panel mt-5 mx-3 mx-md-0"
        v-if="$vuetify.breakpoint.xsOnly"
      >
        <v-col cols="12">
          <!-- <div class="d-flex">
            <v-img src="@/assets/guarantee.svg" width="25" height="25"></v-img>
            <p>Shop with ease with out 14 Day Monkey Back Gurantee</p>
          </div> -->
          <div class="order-cost">
            <div class="d-flex justify-space-between">
              <div>Subtotal</div>
              <div>
                {{ order.price.currency | currencySymbol
                }}{{ order.price.subTotal }}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div>Shipping</div>
              <div>
                {{ order.price.currency | currencySymbol
                }}{{ order.price.shippingFee }}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div>Discount</div>
              <div>
                {{ order.price.currency | currencySymbol
                }}{{ order.price.discount }}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div>Total</div>
              <div>{{ order.price.total }}</div>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row class="checkout-panel mt-5" v-if="$vuetify.breakpoint.smAndUp">
        <v-col cols="12">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="12" md="6" class="cost-panel">
              <v-row>
                <v-col cols="9">
                  <span>Sub Total</span>
                </v-col>
                <v-col cols="2">
                  <span
                    >{{ order.price.currency | currencySymbol
                    }}{{ order.price.subTotal }}</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="9">
                  <span>Shipping</span>
                </v-col>
                <v-col cols="2">
                  <span
                    >{{ order.price.currency | currencySymbol
                    }}{{ order.price.shippingFee }}</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="9">
                  <span>Discount</span>
                </v-col>
                <v-col cols="2">
                  <span
                    >{{ order.price.currency | currencySymbol
                    }}{{ order.price.discount }}</span
                  >
                </v-col>
                
              </v-row>
              <v-row>
                <v-col cols="9">
                  <span>Total</span>
                </v-col>
                <v-col cols="2">
                                    <span>{{ order.price.total }}</span>

                </v-col>
                
              </v-row>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" sm="12" md="9" class="guarantee">
              <v-img src="@/assets/guarantee.svg"></v-img>
              <p>Shop with ease with out 14 Day Monkey Back Gurantee</p>
            </v-col>
            <v-col cols="12" sm="12" md="3" class="total">
              <v-row>
                <v-col cols="6">
                  <span>Total</span>
                </v-col>
                <v-col cols="6">
                  <span>{{ order.price.total }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row> -->
        </v-col>
      </v-row>
     
    </v-container>
    <v-container v-if="$vuetify.breakpoint.xsOnly" class="mobile">
      <div class="text-center confirmation-container">
        <div>
          <h3 class="thank-you">THANK YOU!</h3>
        </div>
        <div class="mt-10">
          <img :src="require('@/assets/order-confirmed.png')" />
        </div>
        <div class="order-placed-description mt-10">
          YOUR ORDER HAS BEEN PLACED
        </div>
        <div class="mt-6">
          <v-btn class="order-number-btn" color="appRed">
            <u>Order# {{ order.number }}</u></v-btn
          >
        </div>
        <div class="appGreen--text font-w-500 gotham-medium font-18 mt-10">
          TRACK THE ORDER DETAILS IN THE APP
        </div>
      </div>
      <v-btn
        class="appGreen--text appGreen--border font-bold"
        block
        outlined
        elevation="0"
        >TRACK YOUR ORDER</v-btn
      >
      <v-btn color="appGreen" class="white--text font-bold mt-3" block
        >BUY MORE PRODUCTS</v-btn
      >
    </v-container>
    <v-container fluid class="pa-0" v-if="$vuetify.breakpoint.smAndUp">
      <home-footer class="d-none d-md-block" />
    </v-container>
    <v-dialog v-model="showShippingEditModal" width="800">
      <v-form ref="shipmentUpdateForm" @submit.prevent="updateShippingAddress">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Update Shipping Address</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="shippingAddress.toBuildingNo"
                    :rules="buildingNoRules"
                    label="Building No"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="shippingAddress.toAddress"
                    :rules="addressRules"
                    label="Address"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="shippingAddress.toCity"
                    :rules="cityRules"
                    label="City"
                    solo
                    flat
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="shippingAddress.toState"
                    :rules="stateRules"
                    label="Postcode"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" md="6" @click.stop>
                  <v-select
                    v-model="shippingAddress.toCountryId"
                    :items="countries"
                    :rules="countryRules"
                    label="Country"
                    solo
                    flat
                    dense
                    value
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="appGreen darken-1" dark type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Breadcrumbs from "@/components/Shared/Breadcrumbs/Breadcrumbs.vue";
import HomeFooter from "@/components/Shared/HomeFooter/HomeFooter.vue";
import helpers from "@/mixins/helpers.js";
export default {
  name: "ConfirmationComponent",
  components: {
    Breadcrumbs,
    HomeFooter
  },
  mixins: [helpers],
  data: () => ({
    breadcrumbs: ["ORTHODONTICS", "MY BASKET"],
    showShippingEditModal: false,
    shippingAddress: {
      toBuildingNo: "",
      toAddress: "",
      toCity: "",
      toState: "",
      toCountryId: ""
    },
    buildingNoRules: [
      v => !!v || "Building no is required",
      v => (v && v.length >= 3) || "Building no must be at least 3 characters",
      v =>
        (v && v.length <= 20) ||
        "Building no must be less than than 20 characters"
    ],
    addressRules: [
      v => !!v || "Address is required",
      v => (v && v.length >= 10) || "Address must be at least 10 characters",
      v =>
        (v && v.length <= 100) ||
        "Address must be less than than 100 characters"
    ],
    cityRules: [
      v => !!v || "City is required",
      v => (v && v.length >= 4) || "City must be at least 4 characters",
      v => (v && v.length <= 35) || "City must be less than than 35 characters"
    ],
    stateRules: [
      v => !!v || "State is required",
      v => (v && v.length >= 4) || "State must be at least 4 characters",
      v => (v && v.length <= 25) || "State must be less than than 25 characters"
    ],
    countryRules: [v => !!v || "Country is required"],
    step: 3
  }),
  mounted() {
    this.$store.dispatch("country/GET_COUNTRIES");
  },
  methods: {
    openShippingEditModal(address) {
      this.shippingAddress = Object.assign({}, address);
      this.showShippingEditModal = true;
    },
    openDescription(description) {
      this.$swal.fire({
        html: description
      });
    },
    async updateShippingAddress() {
      if (this.$refs.shipmentUpdateForm.validate()) {
        this.$swal({
          title: "Updating shipment address",
          html: "This will only take a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          "order/UPDATE_SHIPPING_ADDRESS",
          this.shippingAddress
        );
        this.$swal({
          title: "Success",
          html: "Shipment address updated successfully",
          icon: "info"
        });
        this.showShippingEditModal = false;
        this.$store.dispatch("order/GET_ORDER", this.order.id);
      }
    }
  },
  filters: {
    shortShipmentAddress(address) {
      return `${address.toBuildingNo} ${address.toAddress}, ${address.toCity}, ${address.toState}, ${address.toCountry}`;
    }
  },
  computed: {
    ...mapState({
      orders: state => state.product.basketProducts,
      order: state => state.order.order,
      address: state => state.user.address,
      countries: state => state.country.countries
    }),
    ...mapGetters({
      basketSubTotal: "product/basketSubTotal",
      basketShippingFee: "product/basketShippingFee",
      basketDiscount: "product/basketDiscount",
      basketTotal: "product/basketTotal"
    })
  }
};
</script>
<style scoped lang="scss" src="./Confirmation.scss"></style>
